import React, { PureComponent } from 'react'
import { translate } from 'react-polyglot'
import { Field, FieldArray, reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'

import { Form, Button, Icon, Text, FlexContainer } from 'components'

import { Select, Email } from 'components/FormField'
import { required } from 'utils/validation'

const onPaste = (e, fields, index) => {
	e.preventDefault()

	const { role } = fields.get(index)
	const emails = e.clipboardData
		.getData('text/plain')
		.replace(/\n/g, ',')
		.replace(';', ',')
		.split(',')

	emails.forEach(email => {
		const trimmedEmail = email.trim()

		if (!trimmedEmail.length) {
			return false
		}

		fields.push({
			email: trimmedEmail,
			role,
		})

		return true
	})

	fields.remove(index)
}

const renderInvites = ({
	dispatchChange,
	fields,
	disabled = false,
	meta: { touched, error },
	options,
	t,
}) => (
	<FlexContainer
		flexDirection="column"
		alignItems="flex-start"
		borderBetweenChilds
	>
		{fields.map((invite, index) => (
			<FlexContainer key={index}>
				<Field
					name={`${invite}.email`}
					label={t('forms.email')}
					component={Email}
					// validate={[required]}
					required
					onPaste={e => onPaste(e, fields, index)}
					disabled={disabled}
				/>
				<FlexContainer>
					<div className="c-member-form__role">
						<div className="c-member-form__role-select">
							<Select
								name={`${invite}.role`}
								value={{
									value: fields.get(index).role,
									label: options.find(
										option =>
											option.value ===
											fields.get(index).role
									).label,
								}}
								options={options}
								onChange={obj => {
									dispatchChange(
										`invite`,
										`${invite}.role`,
										obj.value
									)
								}}
								menuPortalTarget={document.getElementById(
									'root'
								)}
								isDisabled={disabled}
							/>
						</div>
					</div>
					<Button
						icon={<Icon name="delete" />}
						fullWidth
						size="small"
						onClick={() => {
							if (fields.length === 1) {
								fields.push({ role: 100 })
							}

							fields.remove(index)
						}}
						disabled={disabled}
					/>
				</FlexContainer>
			</FlexContainer>
		))}
		<Text size="small">
			{t('settings.invites_large_team_text')}
			<br />
			<Button
				layout="underlined-text"
				text={t('settings.invites_large_team_link')}
				onClick={() => fields.push({ role: 100 })}
			/>
		</Text>
	</FlexContainer>
)

class InviteMembersForm extends PureComponent {
	render() {
		const {
			handleSubmit,
			handleReset,
			pristine,
			reset,
			submitting,
			error,
			dispatchChange,
			t,
		} = this.props

		const options = [
			{
				value: 100,
				label: t('settings.user'),
				description: t('settings.user_description'),
			},
			{
				value: 200,
				label: t('settings.billing_admin'),
				description: t('settings.billing_admin_description'),
			},
			{
				value: 300,
				label: t('settings.admin'),
				description: t('settings.admin_description'),
			},
		]

		return (
			<Form
				onSubmit={handleSubmit}
				error={error}
				actions={
					<>
						<Button
							layout="primary"
							text={t('settings.send_invites')}
							type="submit"
							disabled={submitting}
						/>
						<Button
							text={t('cancel')}
							type="reset"
							onClick={e => {
								handleReset()
								reset()
							}}
						/>
					</>
				}
			>
				<FieldArray
					name="invites"
					rerenderOnEveryChange
					component={renderInvites}
					dispatchChange={dispatchChange}
					options={options}
					t={t}
					disabled={submitting}
				/>
			</Form>
		)
	}
}

const mapDispatchToProps = dispatch => ({
	dispatchChange: (formName, field, value) =>
		dispatch(change(formName, field, value)),
})

const reduxFormFilterForm = reduxForm({
	form: 'invite',
})(InviteMembersForm)

export default connect(
	null,
	mapDispatchToProps
)(translate()(reduxFormFilterForm))
